import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=483c079a&"
import script from "./Words.vue?vue&type=script&lang=js&"
export * from "./Words.vue?vue&type=script&lang=js&"
import style0 from "./Words.vue?vue&type=style&index=0&id=483c079a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports